export default __webpack_public_path__ + "static/media/Group 8502_2.3716db40.png";